export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  root: "nav-root",
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkCapabilities: "nav-link-capabilities",
  linkFleet: "nav-link-fleet",
  linkContact: "nav-link-contact",
  quoteBtn: "nav-quote-btn",
  langEn: "lang-toggle-en",
  langEs: "lang-toggle-es",
  mobileMenuBtn: "nav-mobile-menu-btn",
};

export const HERO = {
  root: "hero-root",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const CONTACT_FORM = {
  root: "contact-form",
  name: "contact-input-name",
  company: "contact-input-company",
  email: "contact-input-email",
  phone: "contact-input-phone",
  interest: "contact-input-interest",
  message: "contact-input-message",
  submit: "contact-submit-btn",
  success: "contact-success-msg",
  error: "contact-error-msg",
};

export const STICKY = {
  call: "sticky-call-btn",
  email: "sticky-email-btn",
};
